import { RootState } from '../../reducers/index'
import { CustomFile } from '../../../model/File'

export const createFileByIdSelector =
  (fileId: number) =>
  (state: RootState): Readonly<CustomFile> | null =>
    state.cache.files.details[fileId] || null
